/**
 * More info can be found here https://mobx.js.org/reactions.html#signal-_when_
 * @param e {Error}
 */
export const suppressMobXWhenAbort = (e: Error) => {
  if (e.message !== 'WHEN_ABORTED') {
    throw e
  }
}
